/* @flow */

export default {
  root: {
    marginTop: 12,
  },
  link: {
    minWidth: 'max-content',
  },
};
